import React, { Suspense } from "react";
import { Redirect, Switch, Route } from "react-router";
import { crm } from "../../router/routes";
import CompaniesList from "./CompaniesList";
import CompanyDeatails from "./CompanyDetails";
import AddCompany from "./AddCompany";

const CRM = () => {
  return (
    <>
      <Suspense fallback="Loading">
        <Switch>
          <Route
            exact
            path={`${crm}/companies`}
            render={routeProps => <CompaniesList {...routeProps} />}
            withOutSidebar
          />

          <Route
            exact
            path={`${crm}/company/:id`}
            render={routeProps => <CompanyDeatails {...routeProps} />}
            withOutSidebar
          />

          <Route exact path={`${crm}/add-company`} component={AddCompany} />
          <Redirect to={`${crm}/companies`} />
        </Switch>
      </Suspense>
    </>
  );
};

export default CRM;
